import { CLEAR_DATA_BALANCE, GET_USER_BALANCE, SET_USER_BALANCE } from "../constans";

export interface BalanceState {
  balance: {
    [key: string]: number
  }
}

interface SetUserBalanceAction {
  type: typeof SET_USER_BALANCE;
  payload: { [key: string]: number };
}

interface GetUserBalanceAction {
  type: typeof GET_USER_BALANCE;
}

interface ClearBalanceAction {
  type: typeof CLEAR_DATA_BALANCE;
}

type BalanceActionTypes = SetUserBalanceAction | GetUserBalanceAction | ClearBalanceAction;

const initialState: BalanceState = {
  balance: {}
};

export const userBalanceReduser = (state = initialState, action: BalanceActionTypes): BalanceState => {
  switch (action.type) {
    case SET_USER_BALANCE:
      return {
        ...state,
        balance: action.payload
      };

    case GET_USER_BALANCE:
      return state

    case CLEAR_DATA_BALANCE:
      return {
        ...state,
        balance: {}
      }

    default:
      return state;
  }
}

export const SetUserBalance = (userBalance: { [key: string]: number }) => ({
  type: SET_USER_BALANCE,
  payload: userBalance
});

export const GetUserBalance = () => ({
  type: GET_USER_BALANCE
});

export const clearBalance = () => ({
  type: CLEAR_DATA_BALANCE
})
